import { Module, MutationTree, GetterTree, ActionTree } from 'vuex'
import { RootState } from '@/store'

export type TempState = {
  product: object
}

const state: TempState = {
  product: {
    // new: {}, // 新增的 temp, key=new
    // 90: {} // 編輯的 temp, key=product_id
  }
}

export enum TempGettersTypes {
  GET_PRODUCT_BY_ID = 'GET_PRODUCT_BY_ID',
}

export const getters: GetterTree<TempState, RootState> = {
  [TempGettersTypes.GET_PRODUCT_BY_ID]: (state, getters) => (id : string | number) => {
    if (!id || !state.product[id]) return null

    return state.product[id]
  }
}

export enum TempMutationTypes {
  SET_PRODUCT_BY_ID = 'SET_PRODUCT_BY_ID',
  DELETE_PRODUCT_BY_ID = 'DELETE_PRODUCT_BY_ID',
  CLEAR_ALL = 'CLEAR_ALL'
}

type SetTempPayload = {
  id: string | number
  data: object
}

export const mutations: MutationTree<TempState> = {
  [TempMutationTypes.SET_PRODUCT_BY_ID] (state, payload: SetTempPayload) {
    const { id, data } = payload
    state.product = {
      ...state.product,
      [id]: data
    }
  },
  [TempMutationTypes.DELETE_PRODUCT_BY_ID] (state, payload: string | number) {
    const productID = payload
    if (!productID) return
    const tempProduct = { ...state.product }
    if (tempProduct[productID]) {
      delete tempProduct[productID]
      state.product = tempProduct
    }
  },
  [TempMutationTypes.CLEAR_ALL] (state) {
    state.product = {}
  }
}

export const temp: Module<TempState, RootState> = { state, getters, mutations }
